// extracted by mini-css-extract-plugin
module.exports = {"search":"search-3mRVx","perspective":"perspective-2oprY","filter":"filter-3E9Nx","new-tag":"new-tag-2ptzy","newTag":"new-tag-2ptzy"};